import React from 'react';
import { Select } from 'antd';
import SwaggerUI from 'swagger-ui-react';
import Cookie from 'js-cookie';
import { getRequest } from '@/services';
import { SWAGGER_FILE_PATH } from '@/constants';

import 'swagger-ui-react/swagger-ui.css';
import './index.less';

class SwaggerUIApp extends React.Component {
  swaggerRef = React.createRef();
  
  state = {
    loading: true,
    swaggerOptions: [],
    spec: null,
  };

  componentDidMount() {
    const { swagger_file, virtualDevice } = this.props;
    this.getSwaggerFile(swagger_file || virtualDevice.swagger_file);
  }

  getSwaggerFile = (fileName) => {
    const { link = '', basePath } = this.props;
    const { loading } = this.state;

    !loading && this.setState({ loading: true });

    getRequest(`${SWAGGER_FILE_PATH}/${fileName}`).then((spec) => {
      this.setState({ loading: false });

      if (Array.isArray(spec)) {
        this.setState({ swaggerOptions: spec, spec: null });
      } else if (spec.swagger) {
        // Swagger 2.0
        // Remove protocol
        spec.host = link.replace(/(^\w+:|^)\/\//, '');
        spec.schemes = ['https'];
        spec.basePath = spec.basePath === undefined ? basePath : spec.basePath;

        this.setState({ spec });
      } else if (spec.openapi) {
        // Openapi 3.0
        spec.servers = [
          { url: link + ((spec.basePath === undefined ? basePath : spec.basePath) || '') },
        ];

        this.setState({ spec });
      } else {
        this.setState({ spec: {} });
      }
    });
  };

  render() {
    const {
      link = '',
      basePath,
      headers,
      cookies,
      virtualDevice: {
        api_6500_cookie,
        api_6500_x_xsrf_token,
        api_token,
        api_username,
        api_password,
      },
    } = this.props;
    const { loading, swaggerOptions, spec } = this.state;

    return (
      <div className="swagger-ui-app-container">
        {swaggerOptions.length > 0 && (
          <Select
            showSearch
            placeholder="Please select an API"
            options={swaggerOptions}
            onChange={(value) => this.getSwaggerFile(value)}
          />
        )}
        {loading && <p>Loading Swagger...</p>}
        {!loading && spec && (
          <SwaggerUI
            docExpansion="none"
            spec={spec}
            requestInterceptor={(request) => {
              request.url = decodeURIComponent(request.url);

              if (spec && spec.openapi) {
                request.url = request.url.replace(
                  link.split('?')[0],
                  link + ((spec.basePath === undefined ? basePath : spec.basePath) || ''),
                );
              }

              if (headers) {
                Object.entries(headers).forEach(([key, val]) => {
                  request.headers[key] = val;
                });
              } else if (api_6500_cookie || api_6500_x_xsrf_token) {
                request.headers['X-XSRF-TOKEN'] = api_6500_x_xsrf_token;
                request.headers['apicookie'] = api_6500_cookie;
              } else if (api_token) {
                request.headers['Authorization'] = 'Bearer ' + api_token;
              } else {
                request.headers['Authorization'] =
                  'Basic ' + window.btoa(api_username + ':' + api_password);
              }

              if (cookies) {
                let cookieStr = '';
                Object.entries(cookies).forEach(([key, val]) => {
                  let cookieAttr = {};
                  if (key.startsWith('__Host-')) {
                    cookieAttr = { secure: true, path: '/' };
                  } else if (key.startsWith('__Secure-')) {
                    cookieAttr = { secure: true };
                  }
                  Cookie.set(key, val, cookieAttr);

                  cookieStr += `${key}=${val};`;
                });
                request.headers['Cookie'] = cookieStr;
              }

              return request;
            }}
            responseInterceptor={async (response) => {
              if (response && response.data instanceof Blob) {
                try {
                  const text = await response.data.text();
                  const json = JSON.parse(text);

                  response.data = text;
                  response.text = text;
                  response.body = json;
                  response.obj = json;
                  response.headers['content-type'] = 'application/json;charset=utf-8';
                } catch (err) {
                  console.warn('Blob is not JSON or parse failed:', err);
                }
              }
              return response;
            }}
          />
        )}
      </div>
    );
  }
}

export default SwaggerUIApp;
